import React from 'react';
import { Chip, List, ListItemButton, ListItemText, Stack } from '@mui/material';
import type { RoleView } from '../../Services/agents';
import { buildTree, kindLabel, OrgNode } from './orgHelpers';

interface Props {
	roles: RoleView[];
	selected: string;
	onSelect: (slug: string) => void;
}

// #region OrgTree
// L'organigramme en liste indentée. Le badge « modifié » signale une définition
// surchargée en admin : c'est l'information qu'on cherche en premier quand un plan
// surprend.
export const OrgTree: React.FC<Props> = ({ roles, selected, onSelect }) => {
	const render = (nodes: OrgNode<RoleView>[], depth: number): React.ReactNode =>
		nodes.map(({ item, children }) => (
			<React.Fragment key={item.role.slug}>
				<ListItemButton
					selected={item.role.slug === selected}
					onClick={() => onSelect(item.role.slug)}
					sx={{ pl: 2 + depth * 2.5 }}
				>
					<ListItemText
						primary={item.role.name}
						secondary={
							<Stack direction="row" spacing={0.5} component="span" sx={{ mt: 0.5 }}>
								<Chip size="small" label={kindLabel(item.role.kind)} component="span" />
								{item.source === 'admin' && (
									<Chip size="small" color="secondary" label={`modifié v${item.version}`} component="span" />
								)}
							</Stack>
						}
						secondaryTypographyProps={{ component: 'span' }}
					/>
				</ListItemButton>
				{render(children, depth + 1)}
			</React.Fragment>
		));

	return <List dense>{render(buildTree(roles), 0)}</List>;
};
// #endregion
